(function () {
  'use strict';

  var STORAGE_KEY  = 'o66y_popup_dismissed';
  var CODE_KEY     = 'o66y_popup_code';
  var WORKER_URL   = 'https://o66y-popup-worker.o66yverse.workers.dev/popup-code';

  /* ── Storage helpers ── */
  function isDismissed(expiryDays) {
    try {
      var stored = localStorage.getItem(STORAGE_KEY);
      if (!stored) return false;
      return Date.now() - parseInt(stored, 10) < expiryDays * 864e5;
    } catch (e) { return false; }
  }

  function markDismissed() {
    try { localStorage.setItem(STORAGE_KEY, String(Date.now())); } catch (e) {}
  }

  function saveCode(code, email, expiresAt) {
    try {
      localStorage.setItem(CODE_KEY, JSON.stringify({ code: code, email: email, expires_at: expiresAt || null }));
    } catch (e) {}
  }

  function getSavedCode() {
    try {
      var data = JSON.parse(localStorage.getItem(CODE_KEY) || 'null');
      if (!data) return null;
      if (data.expires_at && new Date(data.expires_at) < new Date()) {
        localStorage.removeItem(CODE_KEY);
        return null;
      }
      return data;
    } catch (e) { return null; }
  }

  /* ── DOM refs ── */
  var overlay, modal, trigger, previousFocus;

  /* ── Countdown ── */
  var countdownInterval;

  function startCountdown(expiresAt) {
    if (countdownInterval) clearInterval(countdownInterval);
    if (!expiresAt) return;

    var cdEl    = document.getElementById('WpCountdown');
    var labelEl = cdEl && cdEl.querySelector('.wp-countdown__label');
    var dEl     = document.getElementById('WpCdDays');
    var hEl     = document.getElementById('WpCdHours');
    var mEl     = document.getElementById('WpCdMins');
    var sEl     = document.getElementById('WpCdSecs');

    function pad(n) { return String(n).padStart(2, '0'); }

    function tick() {
      var remaining = new Date(expiresAt) - Date.now();

      if (remaining <= 0) {
        clearInterval(countdownInterval);
        if (cdEl) cdEl.classList.add('wp-countdown--expired');
        if (labelEl) labelEl.textContent = 'Código vencido';
        try { localStorage.removeItem(CODE_KEY); } catch (e) {}
        return;
      }

      var days  = Math.floor(remaining / 864e5);
      var hours = Math.floor((remaining % 864e5) / 36e5);
      var mins  = Math.floor((remaining % 36e5) / 6e4);
      var secs  = Math.floor((remaining % 6e4) / 1e3);

      if (dEl) dEl.textContent = days;
      if (hEl) hEl.textContent = pad(hours);
      if (mEl) mEl.textContent = pad(mins);
      if (sEl) sEl.textContent = pad(secs);
    }

    tick();
    countdownInterval = setInterval(tick, 1000);
  }

  /* ── Focus trap ── */
  function focusable() {
    return Array.from(modal.querySelectorAll(
      'a[href],button:not([disabled]),input,select,textarea,[tabindex]:not([tabindex="-1"])'
    ));
  }

  function onKeyDown(e) {
    if (e.key === 'Escape') { WelcomePopup.close(); return; }
    if (e.key !== 'Tab') return;
    var els = focusable();
    if (!els.length) return;
    var first = els[0], last = els[els.length - 1];
    if (e.shiftKey) {
      if (document.activeElement === first) { e.preventDefault(); last.focus(); }
    } else {
      if (document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  }

  /* ── Trigger tab ── */
  function showTrigger() { if (trigger) trigger.classList.add('is-visible'); }
  function hideTrigger() { if (trigger) trigger.classList.remove('is-visible'); }

  /* ── Step navigation ── */
  function showStep(id) {
    modal.querySelectorAll('.wp-step').forEach(function (el) {
      el.classList.toggle('wp-step--hidden', el.id !== id);
    });
  }

  /* ── Worker call ── */
  function fetchCode(email, phone, callback) {
    var phoneFormatted = phone ? '+57' + phone.replace(/\D/g, '') : '';
    fetch(WORKER_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email: email, phone: phoneFormatted })
    })
    .then(function (res) { return res.json(); })
    .then(function (data) {
      if (data && data.code) {
        callback(null, data.code, data.expires_at || null);
      } else {
        callback(data.error || 'No se pudo generar el código.');
      }
    })
    .catch(function () {
      callback('Sin conexión. Inténtalo de nuevo.');
    });
  }

  /* ── Public API ── */
  var WelcomePopup = {
    open: function (startAtStep) {
      if (!overlay || overlay.classList.contains('is-open')) return;
      previousFocus = document.activeElement;
      if (startAtStep === 2) showStep('WpStep2');
      overlay.classList.add('is-open');
      overlay.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      document.addEventListener('keydown', onKeyDown);
      hideTrigger();
      var els = focusable();
      if (els.length) els[0].focus();
    },

    close: function () {
      if (!overlay || !overlay.classList.contains('is-open')) return;
      overlay.classList.remove('is-open');
      overlay.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      document.removeEventListener('keydown', onKeyDown);
      markDismissed();
      showTrigger();
      if (previousFocus) previousFocus.focus();
    }
  };

  window.O66YWelcomePopup = WelcomePopup;

  /* ── Init ── */
  document.addEventListener('DOMContentLoaded', function () {
    overlay = document.getElementById('WpOverlay');
    trigger = document.getElementById('WpTrigger');
    if (!overlay) return;
    modal = overlay.querySelector('.wp-modal');

    var delay  = parseInt(overlay.dataset.delay  || '10', 10) * 1000;
    var expiry = parseInt(overlay.dataset.expiry || '30', 10);

    var codeDisplay = document.getElementById('WpCodeDisplay');

    /* Close buttons */
    document.getElementById('WpClose')?.addEventListener('click', WelcomePopup.close);
    document.getElementById('WpClose2')?.addEventListener('click', WelcomePopup.close);
    document.getElementById('WpLater')?.addEventListener('click', WelcomePopup.close);

    /* Trigger click */
    if (trigger) {
      trigger.addEventListener('click', function () {
        var saved = getSavedCode();
        if (saved) {
          if (codeDisplay) codeDisplay.textContent = saved.code;
          startCountdown(saved.expires_at);
        }
        WelcomePopup.open(saved ? 2 : 1);
      });
    }

    /* Click outside */
    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) WelcomePopup.close();
    });

    /* ── Form submission ── */
    var form      = document.getElementById('WpForm');
    var submitBtn = document.getElementById('WpSubmit');
    var errorEl   = document.getElementById('WpError');

    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();

        var emailEl = document.getElementById('WpEmail');
        var phoneEl = document.getElementById('WpPhone');
        if (!emailEl || !phoneEl) return;

        var email = emailEl.value.trim();
        var phone = phoneEl.value.trim();

        if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
          showError('Ingresa un correo electrónico válido.');
          return;
        }
        if (!phone) {
          showError('Ingresa tu número de WhatsApp.');
          return;
        }
        clearError();

        submitBtn.disabled = true;
        submitBtn.classList.add('is-loading');

        fetchCode(email, phone, function (err, code, expiresAt) {
          submitBtn.disabled = false;
          submitBtn.classList.remove('is-loading');

          if (err) {
            showError(err);
            return;
          }

          if (codeDisplay) codeDisplay.textContent = code;
          saveCode(code, email, expiresAt);
          startCountdown(expiresAt);
          showStep('WpStep2');
        });
      });
    }

    function showError(msg) {
      if (errorEl) { errorEl.textContent = msg; errorEl.classList.add('is-visible'); }
    }
    function clearError() {
      if (errorEl) { errorEl.textContent = ''; errorEl.classList.remove('is-visible'); }
    }

    /* ── Copy button ── */
    var copyBtn = document.getElementById('WpCopy');
    if (copyBtn) {
      copyBtn.addEventListener('click', function () {
        var text = (document.getElementById('WpCodeDisplay') || {}).textContent || '';
        if (!text) return;
        navigator.clipboard?.writeText(text).then(function () {
          copyBtn.classList.add('is-copied');
          setTimeout(function () { copyBtn.classList.remove('is-copied'); }, 2000);
        }).catch(function () {
          var ta = document.createElement('textarea');
          ta.value = text;
          ta.style.position = 'fixed';
          ta.style.opacity = '0';
          document.body.appendChild(ta);
          ta.select();
          document.execCommand('copy');
          document.body.removeChild(ta);
          copyBtn.classList.add('is-copied');
          setTimeout(function () { copyBtn.classList.remove('is-copied'); }, 2000);
        });
      });
    }

    /* ── Auto-open logic ── */
    var saved = getSavedCode();

    if (saved) {
      if (codeDisplay) codeDisplay.textContent = saved.code;
      startCountdown(saved.expires_at);
      showTrigger();
      return;
    }

    if (isDismissed(expiry)) {
      showTrigger();
      return;
    }

    setTimeout(function () { WelcomePopup.open(1); }, delay);
  });
})();
